const firebaseConfig = {
    apiKey: "AIzaSyDtRCF3m4HNuMehfOh9M9W2tj-YUsKU7U4",
    authDomain: "health-website-cb56e.firebaseapp.com",
    projectId: "health-website-cb56e",
    storageBucket: "health-website-cb56e.appspot.com",
    messagingSenderId: "742089092803",
    appId: "1:742089092803:web:37bb62069ddeec5ccdbc76"
  };

  export default firebaseConfig;